// extracted by mini-css-extract-plugin
module.exports = {"header":"TopSearches_header__3YDyW","container":"TopSearches_container__3ICLe","rowTitle":"TopSearches_rowTitle__z4DA6","rowDescription":"TopSearches_rowDescription__2k9d0"};